export default "__VITE_ASSET__BFvkxOPY__"